import React, { useEffect, useState, useContext } from "react";
import { Input, Button, Grid, Typography } from "antd";
import { MenuOutlined, SearchOutlined } from "@ant-design/icons";
import NavbarActions from "./NavbarActions";
import logo from "../assets/logos/logo192.png";
import "./css/NavbarTopHorizontal.css";
import { Link } from "react-router-dom";
import coreFunctions from "src/common/utils/coreFunctions";

const { useBreakpoint } = Grid;

interface NavbarTopHorizontalProps {
  toggleDrawer: () => void;
}

const NavbarTopHorizontal: React.FC<NavbarTopHorizontalProps> = ({
  toggleDrawer,
}) => {
  const [theme, setTheme] = useState<"light" | "dark">("light");
  const screens = useBreakpoint();

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    document.body.setAttribute("data-theme", newTheme);
  };

  return (
    <div className="navbar-container">
      {/* Menu Button for Small Screens */}
      {!screens.md && (
        <Button
          className="menu-button"
          icon={<MenuOutlined />}
          onClick={toggleDrawer}
        />
      )}

      {/* Logo */}
      <div className="navbar-logo">
        <Link to="/dashboard">
          {/* <img src={logo} alt="Logo" style={{ maxWidth: "70%" }} /> */}
          <Typography.Title level={coreFunctions.isMobileDevice() ? 4 : 3}>
            Mallika TS
          </Typography.Title>
        </Link>
      </div>

      {screens.md && (
        <div className="navbar-search">
          <Input
            placeholder="Search..."
            prefix={<SearchOutlined />}
            className="search-input"
          />
        </div>
      )}

      {/* Action Buttons */}
      <NavbarActions theme={theme} toggleTheme={toggleTheme} />
    </div>
  );
};

export default NavbarTopHorizontal;
